import {
  Container,
  Stack,
  Box,
  Text,
  Heading,
  Badge,
  Button,
  Divider,
  useColorModeValue,
} from "@chakra-ui/react";
import { ArrowBackIcon } from "@chakra-ui/icons";
import { motion } from "framer-motion";
import { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import t from "../translations";

const MotionBox = motion(Box);

export default function LearningDetailPage({ color = "purple" }) {
  const { slug } = useParams();
  const navigate = useNavigate();
  const textColor = useColorModeValue("gray.600", "gray.400");

  let entry = null;
  let category = null;
  let tabIndex = 0;
  for (let i = 0; i < t.learnings.categories.length; i++) {
    const cat = t.learnings.categories[i];
    const found = cat.entries.find((e) => e.slug === slug);
    if (found) {
      entry = found;
      category = cat;
      tabIndex = i;
      break;
    }
  }

  useEffect(() => {
    if (entry) {
      document.title = `${entry.title} ${t.learnings.pageTitleSuffix}`;
    }
  }, [entry]);

  if (!entry) {
    navigate("/learnings", { state: { tabIndex } });
    return null;
  }

  return (
    <Container maxW="3xl" pt={{ base: 20, md: 28 }} pb={{ base: 16, md: 36 }} px={{ base: 4, md: 8 }}>
      <Stack spacing={8}>
        <Button
          leftIcon={<ArrowBackIcon />}
          variant="ghost"
          colorScheme={color}
          alignSelf="flex-start"
          onClick={() => navigate("/learnings", { state: { tabIndex } })}
          size="sm"
        >
          {t.learnings.backButton}
        </Button>

        <MotionBox
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, ease: "easeOut" }}
        >
          <Stack spacing={8}>
            <Stack spacing={3}>
              <Badge
                colorScheme={category.color}
                borderRadius="full"
                px={3}
                py={1}
                fontSize="sm"
                alignSelf="flex-start"
              >
                {category.label}
              </Badge>
              <Heading size={{ base: "lg", md: "xl" }}>{entry.title}</Heading>
            </Stack>

            <Divider />

            <Text
              color={textColor}
              fontSize="md"
              lineHeight={1.9}
              fontWeight={500}
            >
              {entry.body}
            </Text>

            <Divider />

            {entry.expanded.split("\n\n").map((paragraph, i) => (
              <Text
                key={i}
                color={textColor}
                fontSize="md"
                lineHeight={1.9}
              >
                {paragraph}
              </Text>
            ))}
          </Stack>
        </MotionBox>
      </Stack>
    </Container>
  );
}
